import React, { useEffect, useState } from "react";
import Icon from "../icons";
import { CheckboxSelect } from "../DropDown";
import { DateRangePicker } from "../Calender";
import { APIService } from "../../Service";
import { PrimaryButton } from "../Cta";

export default function CustomerFilter({
  selectedFilters,
  setSelectedFilters,
}) {
  const [loader, setLoader] = useState(false);
  const [filter, setFilter] = useState(null);
  const [analyticsDateRange, setAnalyticsDateRange] = useState([
    new Date(),
    new Date(),
  ]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    _getFilterData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  //   handleReset();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [curTab]);

  const _getFilterData = () => {
    setLoader(true);
    let is_post = false;
    let url = "user/filter-data";
    APIService(is_post, url).then((response) => {
      // console.log(response);
      
      if (response.status_code === 200) {
        const data = response.data;
        if (data) {
          setFilter(data);
        } else {
          setFilter(null);
          // setSelectedFilters({});
        }
      } else {
        setFilter(null);
        // setSelectedFilters({});
      }
      setLoader(false);
    });
  };

  const _handleOpen = (e) => {
    e.stopPropagation();
    setOpen((prev) => !prev);
  };

  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const _handleAnalyticsDateRangeChange = (range) => {
    setAnalyticsDateRange(range);
    setSelectedFilters((prev) => ({
      ...prev,
      from_date: formatDate(range[0]),
      to_date: formatDate(range[1]),
    }));
  };

  const handleSelectChangeFor = (key, selected) => {
    if (!selected) {
      setSelectedFilters((prev) => ({ ...prev, [key]: null })); // null if cleared
      return;
    }

    // single object -> scalar value
    if (!Array.isArray(selected)) {
      const val = selected.value !== undefined ? selected.value : null;
      setSelectedFilters((prev) => ({ ...prev, [key]: val }));
      return;
    }

    // If multi-select is enabled, fallback to array
    const normalized = selected.map((s) =>
      s && typeof s === "object" && "value" in s ? s.value : s
    );
    setSelectedFilters((prev) => ({ ...prev, [key]: normalized }));
  };

  const handleReset = () => {
    if (!filter) return;

    const cleared = {};
    Object.keys(filter).forEach((k) => {
      if (Array.isArray(filter[k])) {
        cleared[k] = null; // reset single-selects to null
      }
    });

    cleared.from_date = "";
    cleared.to_date = "";

    setSelectedFilters(cleared);
    setAnalyticsDateRange([null, null]);
    setOpen(false);
  };

  // const handleApply = () => {
  //   const payload = {
  //     date_from: analyticsDateRange[0],
  //     date_to: analyticsDateRange[1],
  //     ...selectedFilters,
  //   };
  //   console.log("Applying filters payload:", payload);
  //   // call API or lift to parent here
  // };

  const formatPlaceholder = (key) => {
    const withSpaces = key.replace(/_/g, " ");
    return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1);
  };

  return (
    <div className="e-filter-wrapper">
      <div
        onClick={(e) => {
          if (!loader) _handleOpen(e);
        }}
        className={`e-filter px-3 py-2 d-flex column-gap-2 justify-content-center align-items-center e-font-14 e-primary-font-poppins e-font-weight-500 ${
          open ? "e-text-blue-violet" : ""
        } ${
          loader
            ? "e-text-silver cursor-not-allowed"
            : "e-cursor-pointer e-border-1px-silver"
        }`}
      >
        <Icon icon="filter-black" size="20px" />
        {open ? "Filter By" : "Filter"}
      </div>

      {open && (
        <div className="d-flex align-items-center e-filter-body py-0 position-absolute mt-2 rounded-3 e-bg-magnolia z-3 px-3 text-nowrap">
          <div className="d-flex align-items-center ps-0 my-1">
            <DateRangePicker
              type={2}
              lableName="Joined date"
              value={analyticsDateRange}
              background="e-bg-white"
              ClassName=""
              calenderPosition="e-dashboard-calender"
              onChange={_handleAnalyticsDateRangeChange}
            />
          </div>

          {filter
            ? Object.keys(filter).map((key) => {
                const group = filter[key];
                if (!Array.isArray(group)) return null;

                const placeholder = formatPlaceholder(key);
                const valueArray = selectedFilters[key] || [];

                return (
                  <div className="px-0 " key={key}>
                    <CheckboxSelect
                      isMulti={false}
                      placeholder={placeholder}
                      options={group}
                      selectedOptions={valueArray}
                      selectChange={(selected) =>
                        handleSelectChangeFor(key, selected)
                      }
                      isSearchable={false}
                      isClearable={true}
                      isDisabled={false}
                      error={null}
                      className="rounded-pill py-0"
                      type={key === "risk_score" ? 3 : 2}
                      optional={false}
                    />
                  </div>
                );
              })
            : null}

          <div className="d-flex align-items-center column-gap-2 pt-1">
            <PrimaryButton
              onPress={handleReset}
              size="16px"
              icon="reset"
              name="Reset Filter"
              ClassName="bg-transparent e-primary-font-poppins e-text-persian-red p-0 e-font-14 e-font-weight-400"
            />
          </div>
        </div>
      )}
    </div>
  );
}
